import { c as _c } from "react/compiler-runtime";
import { isSeatSoldOut, NO_FREE_SEAT_REASON } from "@components/table/members/assign-seats/assign-seats-utils";
import { Text } from "@flat-ui";
/**
 * Returns what checking or unchecking the seat does to the seats of the workspace, that the member
 * holds it already, or that none is left to give. Nothing for a seat the member does not hold and
 * does not get.
 */
function getSeatUsage(option, isChecked, seatsAvailable) {
  if (option.isHeld) {
    return isChecked ? "Assigned" : "Frees 1 seat";
  }
  if (isSeatSoldOut(option)) {
    return NO_FREE_SEAT_REASON;
  }
  if (!isChecked) {
    return null;
  }
  return <>
      Uses 1 of <var>{seatsAvailable}</var> remaining{" "}
      {seatsAvailable === 1 ? "seat" : "seats"}
    </>;
}

/**
 * Plain text in the corner of a seat card that tells whether the member holds the seat, how many
 * seats of the workspace checking or unchecking it uses or frees, or that none is left.
 */
export function SeatUsageText(t0) {
  const $ = _c(7);
  const {
    option,
    isChecked,
    seatsAvailable
  } = t0;
  let t1;
  if ($[0] !== isChecked || $[1] !== option || $[2] !== seatsAvailable) {
    t1 = getSeatUsage(option, isChecked, seatsAvailable);
    $[0] = isChecked;
    $[1] = option;
    $[2] = seatsAvailable;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const usage = t1;
  if (!usage) {
    return null;
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "text.secondary",
      flexShrink: 0,
      whiteSpace: "nowrap"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== usage) {
    t3 = <Text variant="bodyS" component="span" sx={t2}>{usage}</Text>;
    $[5] = usage;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}